import { __decorate } from "tslib";
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
let LabelInput = class LabelInput extends Vue {
    value;
    editMode;
    emitInput(val) {
        return val;
    }
    $refs;
    localValue = '';
    valueWatcher(newVal) {
        this.localValue = newVal;
    }
    removeFocus(e) {
        if (e.code === 'Enter') {
            this.$refs.labelInput.blur();
            this.emitInput(this.localValue);
        }
    }
};
__decorate([
    Prop({ required: true })
], LabelInput.prototype, "value", void 0);
__decorate([
    Prop({ type: Boolean, required: true })
], LabelInput.prototype, "editMode", void 0);
__decorate([
    Emit('input')
], LabelInput.prototype, "emitInput", null);
__decorate([
    Watch('value')
], LabelInput.prototype, "valueWatcher", null);
LabelInput = __decorate([
    Component({})
], LabelInput);
export default LabelInput;
